module.exports = __webpack_public_path__ + "static/media/youtube_icon.94e2aca2.svg";